import React, {Component} from 'react'
import PropTypes from 'prop-types'
import RenderBody from './RenderBody'
import {connect} from 'react-redux'
import {INFO, INFO_TYPE_INFO, INFO_TYPE_ERROR, INFO_TYPE_WARNING, INFO_TYPE_PRIMARY, hideModal} from "../../../modules/modals"
import cn from 'classnames'


class InfoModal extends Component {
    render() {
        const {zIndex, title} = this.props
        const {formatMessage} = this.context

        return (
            <RenderBody
                zIndex = {zIndex}
                title = {formatMessage(title)}
                render = {this._render}
                modalType = {INFO}
                handleClose = {this.hideModal}
                titleClassName = {this._getTitleClassName()}
            />
        )
    }

    _getTitleClassName = () => {
        const {infoType = INFO_TYPE_INFO} = this.props
        return cn({
            "create-dialog-modal-content__title--info" : infoType === INFO_TYPE_INFO,
            "create-dialog-modal-content__title--primary" : infoType === INFO_TYPE_PRIMARY,
            "create-dialog-modal-content__title--warning" : infoType === INFO_TYPE_WARNING,
            "create-dialog-modal-content__title--error" : infoType === INFO_TYPE_ERROR
        })
    }

    _render = () => {
        const {text, infoType = INFO_TYPE_INFO} = this.props
        const {formatMessage} = this.context
        return (
            <form className="create-dialog-form">
                <div className="row mb-5">
                    <div className={cn("col-xs-12 text-center", {
                        "text-info" : infoType === INFO_TYPE_INFO,
                        "text-primary" : infoType === INFO_TYPE_PRIMARY,
                        "text-waring" : infoType === INFO_TYPE_WARNING,
                        "text-danger" : infoType === INFO_TYPE_ERROR,
                    })}>{formatMessage(text)}</div>
                </div>
                <div className="create-dialog-form__group flex">
                    <button
                        onClick={this.hideModal}
                        className="btn btn-primary mr-auto ml-auto"
                        type="button"
                    >{formatMessage(`Ok`)}</button>
                </div>
            </form>
        )
    }

    hideModal = () => {
        let {successCB, hideModal} = this.props
        hideModal({modalType:INFO})
        if (typeof successCB === 'function') successCB()
    }

    static contextTypes = {formatMessage: PropTypes.func}
}

export default connect(null, {hideModal})(InfoModal)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/modals/common/Info.js